import {setI18n} from "./i18n";

export const initLang = (lang='en') => {
  setI18n(lang)
}
